import { IFormatQuestion } from "./formatApplication";

export const normalizeQuestionsIds = (questionData: IFormatQuestion) => {
    const alternatives = !Array.isArray(questionData?.answers_data) ? [questionData?.answers_data] : questionData?.answers_data;

    for (let i = 0; i < alternatives.length; i++) {
      alternatives[i]!.id = i + 1;
    }
    return alternatives;
  }